import { Trans, useTranslation } from 'react-i18next';

import { XCloseIcon } from 'icons';
import { colors } from 'styles/colors';

import { BtnDanger } from '../../styles';
import {
  ProgressWrap, ProgressTop, Spinner, ProgressInfo, ProgressInfoTitle, ProgressInfoSub,
  DeadlineBadge, ProgressBarWrap, ProgressBarFill, ProgressSteps, ProgressStep,
  InstructionsBox, InstructionsTitle, InstructionItem, ProgressActions,
} from './styles';

interface ProgressStateProps {
  deadlineLabel: string;
  durationMinutes: number;
  onCancel: () => void;
  isCanceling: boolean;
}

export const ProgressState = ({
  deadlineLabel, durationMinutes, onCancel, isCanceling,
}: ProgressStateProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <ProgressWrap>
      <ProgressTop>
        <Spinner />
        <ProgressInfo>
          <ProgressInfoTitle>{t('validacaoEmAndamento')}</ProgressInfoTitle>
          <ProgressInfoSub>{t('validacaoVerificandoParametros')}</ProgressInfoSub>
        </ProgressInfo>
        <DeadlineBadge>{t('prazoMaximoValidacao', { time: deadlineLabel })}</DeadlineBadge>
      </ProgressTop>
      <ProgressBarWrap>
        <ProgressBarFill />
      </ProgressBarWrap>
      <ProgressSteps>
        <ProgressStep $running>{t('analiseTermodinamica')}</ProgressStep>
      </ProgressSteps>
      <InstructionsBox>
        <InstructionsTitle>{t('lembreDuranteValidacao')}</InstructionsTitle>
        <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
          <InstructionItem>
            <span><Trans i18nKey="instrucaoValidacao1" components={{ strong: <strong /> }} /></span>
          </InstructionItem>
          <InstructionItem>
            <span>{t('instrucaoValidacao2', { minutes: durationMinutes })}</span>
          </InstructionItem>
        </ul>
      </InstructionsBox>
      <ProgressActions>
        <BtnDanger onClick={onCancel} disabled={isCanceling}>
          <XCloseIcon size="14" color={colors.Red} />
          {t('cancelarValidacao')}
        </BtnDanger>
      </ProgressActions>
    </ProgressWrap>
  );
};
